import { Component, OnInit } from '@angular/core';
import {UiService} from '../../services/ui-service/ui.service';
import {ApiService} from '../../services/api-service/api.service';

@Component({
  selector: 'app-page-contacts',
  templateUrl: './page-contacts.component.html',
  styleUrls: ['./page-contacts.component.scss']
})
export class PageContactsComponent implements OnInit {

  public settings: any[];

  openModal = (event) => {
    this.UIService.toggleCallbackModal(event);
  }

  constructor(private UIService: UiService,private apiService: ApiService) {
    this.settings = this.apiService.settings;
  }


  ngOnInit() {
  }

}
